import { type CompanySettings } from "../utils/types";

export const DEFAULT_SETTINGS: CompanySettings = {
  displayNetworkLogs: {
    type: "boolean",
    value: true,
    label: "Display network logs",
  },
  // location: {
  //   type: "string",
  //   value: "40.75684279398277, -73.98450146642257",
  //   label: "Location",
  // },
  parallelRuns: {
    type: "number",
    value: 1,
    label: "Number of parallel runs",
    disabled: true,
  },
  // Read-only here, like parallelRuns above: both are sold, not
  // self-served, so support sets them straight on settings/{orgId} and this
  // screen exists to show what an organisation actually has. 0 is what an
  // unset field displays as, and it is honest - it means the two budgets
  // are not split and generations queue on parallelRuns, which is what
  // every organisation gets until we split them.
  parallelRunsGenerations: {
    type: "number",
    value: 0,
    label:
      "Parallel runs for writing tests (0 = shares the parallel runs budget)",
    disabled: true,
  },
  numberOfRetriesOnFailure: {
    type: "dropdown",
    value: 0,
    label: "Number of retries after failed test",
    options: [0, 1, 2, 3],
  },
  waitForStableScreenTime: {
    type: "number",
    value: 3000,
    label: "Wait for stable screen time (ms)",
    disabled: false,
  },
  webhookSlack: {
    type: "string",
    value: "",
    label: "Slack Webhook URL (on suite completion)",
  },
  webhookUrl: {
    type: "string",
    value: "",
    label: "Custom Webhook URL (on single test or suite)",
  },
  webhookTrigger: {
    type: "dropdown",
    value: "whole suite completion",
    label: "Custom Webhook Trigger",
    options: [
      "whole suite completion",
      "single test run",
      "both: whole suite completion and single test run",
    ],
  },
  webhookAuthHeader: {
    type: "string",
    value: "",
    label: "Custom Webhook Authorization Header (optional)",
    tooltip:
      "This value will be used directly in the POST request header: { Authorization: <value> }",
  },
  customHeaders: {
    type: "map",
    value: [],
    label: "Custom Webhook Headers (optional)",
  },
  region: {
    type: "dropdown",
    value: "automatic",
    label: "Region",
    options: ["automatic", "us", "eu"],
  },
  autoGrantPermissions: {
    type: "boolean",
    value: false,
    label: "Automatically grant permissions",
    documentationLink:
      "https://docs.mobileboost.io/best-practices/auto-grant-permissions",
  },
  enableMarkdownEditor: {
    type: "boolean",
    value: false,
    label: "Markdown test editor",
    tooltip:
      "Authors create tests as markdown that an LLM expands into an abstract test task. Required for the auto-failure review loop.",
  },
  enableAutoFailureReviewLoop: {
    type: "boolean",
    value: false,
    label: "Auto-failure review loop",
    tooltip:
      "When a cloud run fails on a markdown-authored test, automatically classify the failure as a legitimate app issue or agentic failure and retry up to 2× with a refined test definition. Requires the markdown test editor.",
    // `disabled` is set at render time in CompanySettingsPanel based on
    // the live value of `enableMarkdownEditor`. We deliberately leave it
    // unset here so `saveSettingsToFirestore` (which skips disabled
    // fields, see firebase_operations.tsx:352) still persists this
    // field's value.
  },
  enableAutoSuccessVerification: {
    type: "boolean",
    value: false,
    label: "Auto-success verification",
    tooltip:
      "When a cloud run on a markdown-authored test succeeds, automatically verify the success criteria were genuinely met. If the agent passed too easily, refine the test and re-run up to 2×; if it still falsely passes, flip the run to failed. Roughly doubles LLM spend per cloud run. Requires the markdown test editor.",
    // Same render-time disabled logic as `enableAutoFailureReviewLoop`.
  },
};
